import { MemberPreference } from 'node-api/members/member.types';

export function getPreferenceByName(
  listOfPreferences: MemberPreference[],
  preferenceName: string
): MemberPreference | null {
  return listOfPreferences.find(({ preference }) => preference.name === preferenceName) || null;
}
